<template>
  <div class="ts-justify-start">
    <!-- File Image -->
    <img
      v-if="isImage && !isIcon"
      class="h-full w-full rounded-lg object-cover shadow-lg"
      :src="entry.data.attributes.attach_file_path"
      alt=""
      loading="lazy"
      style="max-height: 106px"
    />
    <i
      v-if="isImage && isIcon"
      :class="iconSize"
      class="fas fa-file-image text-primary"
    ></i>
    <!-- File PDF -->
    <i v-if="isPdf" :class="iconSize" class="fas fa-file-pdf text-danger"></i>
    <!-- File Word -->
    <i
      v-if="isWord"
      :class="iconSize"
      class="fas fa-file-word ts-text-blue-700"
    ></i>
    <!-- File Excel -->
    <i
      v-if="isExcel"
      :class="iconSize"
      class="fas fa-file-excel ts-text-green-500"
    ></i>
  </div>
</template>

<script>
export default {
  name: 'FileIconThumbnail',
  props: ['entry', 'iconSize', 'isIcon'],
  computed: {
    isImage() {
      const mime = this.entry.data.attributes.attach_file_mime_type
      return mime && mime.indexOf('image/') === 0
    },
    isPdf() {
      return (
        this.entry.data.attributes.attach_file_mime_type === 'application/pdf'
      )
    },
    isWord() {
      return (
        this.entry.data.attributes.attach_file_mime_type ===
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      )
    },
    isExcel() {
      return (
        this.entry.data.attributes.attach_file_mime_type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      )
    }
  }
}
</script>
